import type { SingleValue } from "react-select";
import type { Option, SharedSelectProps } from "./internal/types";
import useTranslation from "@hooks/use_translation";
import { useSharedReactSelectProps } from "./internal/hooks/use_shared_react_select_props";
import { SelectWrapper } from "./internal/select_wrapper";
import { useReactSelect } from "./internal/hooks/use_react_select";

interface SingleSelectProps extends SharedSelectProps {
  portalMenu?: boolean;
  onChange: (value: Option | null) => void;
  value: Option | null;
}

export const SingleSelect = ({
  clearable = false,
  creatable = false,
  disabled = false,
  error,
  helperText,
  hideLabel = false,
  label,
  onChange,
  options,
  placeholder,
  portalMenu,
  required = false,
  value,
  ref,
  ...dataProps
}: SingleSelectProps) => {
  const { t } = useTranslation("sprout");
  const { id, ...sharedReactSelectProps } = useSharedReactSelectProps(
    (newValue) => onChange(newValue as SingleValue<Option>),
    { error, label: hideLabel ? null : label, portalMenu },
  );
  const ReactSelect = useReactSelect({ creatable });

  return (
    <SelectWrapper
      selectId={id}
      label={label}
      hideLabel={hideLabel}
      error={error}
      helperText={helperText}
      disabled={disabled}
      {...dataProps}
      required={required}
      ref={ref}
    >
      <ReactSelect
        id={id}
        {...sharedReactSelectProps}
        isClearable={clearable}
        isDisabled={disabled}
        options={options}
        placeholder={placeholder || t("select.placeholder")}
        value={value}
      />
    </SelectWrapper>
  );
};
